// extracted by mini-css-extract-plugin
export var searchWrapper = "searchFilter-module--searchWrapper--37760";